import React, { FC, memo } from 'react'
import styled, { css } from 'styled-components'
import Checkbox from 'uiComponents/atoms/Checkbox/Checkbox'
import { HeadingXS } from 'uiComponents/atoms/Text/Headings'
import { textBlack } from 'uiComponents/constants/colors'
import { fwMediumBold } from 'uiComponents/constants/typography'

const MAX_ITEMS = 12

const FilterValue = styled.label<{
  isCollapsed: boolean
  isListCollapsed: boolean
  singleColumn?: boolean
}>`
  display: flex;
  align-items: center;
  flex: 50%;
  width: 50%;
  margin-bottom: 15px;
  transition: 0.25s ease;

  ${props =>
    props.isListCollapsed &&
    css`
      :nth-child(${MAX_ITEMS - 1}),
      :nth-child(${MAX_ITEMS}) {
        margin-bottom: 0;
      }
    `};

  ${props =>
    props.isCollapsed &&
    css`
      opacity: 0;
      max-height: 0;
      font-size: 0;
      margin-bottom: 0;
      pointer-events: none;
    `};

  ${props =>
    props.singleColumn &&
    css`
      flex: 100%;
      width: 100%;
    `};
`

const FilterName = styled(HeadingXS)`
  color: ${textBlack};
  margin-left: 10px;
  flex: 0 80%;
  ${fwMediumBold};
`

export const FilterCheckboxItem: FC<{
  id: string
  isListCollapsed: boolean
  index: number
  name: string
  checked: boolean
  toggleSelection: (id: string) => void
  singleColumn?: boolean
}> = memo(function FilterItem({
  id,
  isListCollapsed,
  index,
  checked,
  name,
  toggleSelection,
  singleColumn = false,
}) {
  return (
    <FilterValue
      data-testid="FilterValue"
      key={id}
      htmlFor={id}
      isCollapsed={isListCollapsed && index + 1 > MAX_ITEMS}
      isListCollapsed={isListCollapsed}
      singleColumn={singleColumn}
    >
      <Checkbox
        checked={checked}
        id={id}
        onChange={() => toggleSelection(id)}
      />
      <FilterName data-testid={'FilterName_' + name}>{name}</FilterName>
    </FilterValue>
  )
})
